import React from 'react';
import PropTypes from 'prop-types';

import { Spacer } from '@zillow/constellation';

import { StyledHeading, StyledSubheading } from './StyledComponents';

const propTypes = {
    children: PropTypes.node.isRequired,
    heading: PropTypes.string.isRequired,
    subheading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]).isRequired,
};

const defaultProps = {};

const PhoneVerificationBodyTemplate = ({
    children,
    heading,
    subheading,
}) => (
    <Spacer marginTop="sm">
        <StyledHeading as="div">{heading}</StyledHeading>
        {typeof subheading === 'string' ? (
            <StyledSubheading>{subheading}</StyledSubheading>
        ) : subheading}
        {children}
    </Spacer>
);

PhoneVerificationBodyTemplate.propTypes = propTypes;
PhoneVerificationBodyTemplate.defaultProps = defaultProps;

export default PhoneVerificationBodyTemplate;
